// import shop from '../api/shop'

const state = {
  items: [],
  CheckoutStatus: null
}

// getters
const getters = {
  // 可返回购物车的总金额
  CartTotalPrice: (state, getters) => {
    return getters.CartProducts.reduce((total, product) => {
      return (total = total + product.quantity * product.price)
    }, 0)
  },

  // 可返回购物车里商品的总重量
  CartTotalWeight: (state, getters) => {
    return getters.CartProducts.reduce((total, product) => {
      total = total + product.quantity * product.weight
      return total
    }, 0)
  },

  // 可返回购物车商品的总数量
  CartTotalQuantity: (state, getters) => {
    return getters.CartProducts.reduce((total, product) => {
      total = total + product.quantity
      return total
    }, 0)
  },

  CartProducts: state => {
    return state.items.map(item => {
      return {
        id: item.id,
        goodsname: item.goodsname,
        price: item.price,
        quantity: item.quantity,
        srcimg: item.srcimg,
        weight: item.weight,
        specialdiscount: item.specialdiscount
      }
    })
  },
  GetItems: (state, getters) => {
    return state.items
  }
}

// actions
const actions = {
  // 下单，清空购物车
  CheckOut ({ commit }) {
    commit('SetCheckoutStatus', null)

    commit('ClearCartItems')
  },

  // 从购物车减去商品
  DeleteProductFromCart ({ state, commit }, product) {
    const cartItem = state.items.find(item => item.id === product.id)

    if (cartItem && cartItem.quantity > 1) {
      commit('MinusItemQuantity', product)
    } else {
      state.items.splice(state.items.indexOf(cartItem), 1)
      // state.items.pop(cartItem) // 再减1 就清空
    }
  },
  // 往购物车添加商品
  AddProductToCart ({ state, commit }, product) {
    // 'id':        this.GetGoods_ID,
    // 'goodsname': this.GetGoodsName,
    // 'price':     this.GetUserGradePrice,
    // 'weight':    this.GetWeight,
    // 'srcimg':    this.SrcImg,
    // 'quantity':  1

    commit('SetCheckoutStatus', null)

    if (state.items.length <= 0) {
      commit('PushProductToCart', product)
    } else {
      const cartItem = state.items.find(item => item.id === product.id)
      if (!cartItem) {
        commit('PushProductToCart', product)
      } else {
        commit('IncrementItemQuantity', product)
      }
    }
  }
}

// mutations
const mutations = {
  PushProductToCart (state, product) {
    state.items.push(product)
  },

  IncrementItemQuantity (state, product) {
    const cartItem = state.items.find(item => item.id === product.id)
    cartItem.quantity = cartItem.quantity + product.quantity // product.quantity = 1  由调用端赋值为1
  },

  MinusItemQuantity (state, product) {
    const cartItem = state.items.find(item => item.id === product.id) // product.quantity = 1 由调用端赋值为1
    cartItem.quantity = cartItem.quantity - product.quantity
  },

  //
  SetCartItems (state, { items }) {
    state.items = items
  },
  // 清空购物车
  ClearCartItems (state) {
    state.items.splice(0, state.items.length)
    state.items = []
  },

  SetCheckoutStatus (state, status) {
    state.CheckoutStatus = status
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/cart.js